// Interfaces para configuração do componente tabela-paginada-primary

export interface TableColumn {
  /** Chave do campo no objeto de dados */
  field: string;
  /** Título exibido no header da coluna */
  header: string;
  /** Se a coluna permite ordenação (default: true) */
  sortable?: boolean;
  /** Largura da coluna (ex: '150px', '20%') */
  width?: string;
  /** Tipo do campo para formatação automática */
  type?: 'text' | 'date' | 'datetime' | 'number' | 'currency' | 'boolean' | 'custom';
  /** Alinhamento do conteúdo */
  align?: 'left' | 'center' | 'right';
  /** Se deve usar template customizado */
  useTemplate?: boolean;
  /** Nome do template a ser usado (para ng-template) */
  templateName?: string;
  /** Classe CSS adicional para a célula */
  cellClass?: string;
  /** Função para formatar o valor (opcional) */
  formatter?: (value: any, row: any) => string;
}

export interface SortEvent {
  /** Campo sendo ordenado */
  field: string;
  /** Direção da ordenação */
  direction: 'asc' | 'desc';
}

export interface PageEvent {
  /** Índice da página atual (1-based) */
  page: number;
  /** Tamanho da página */
  pageSize: number;
  /** Número total de registros */
  totalRecords: number;
  /** Ordenação atual */
  sort?: SortEvent;
}

export interface TablePreferences {
  /** Quantidade de itens por página */
  pageSize: number;
  /** Ordenação padrão */
  defaultSort?: SortEvent;
  /** Campos das colunas ocultas */
  colunasOcultas?: string[];
  /** Ordem dos campos das colunas */
  colunasOrdem?: string[];
}

export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50, 100] as const;
export type PageSizeOption = typeof PAGE_SIZE_OPTIONS[number];

export const DEFAULT_PAGE_SIZE: PageSizeOption = 10;
export const STORAGE_KEY_PREFIX = 'tabela_prefs_';
